module.exports = __webpack_public_path__ + "img/ez-slot-category-skill-game.6f72f06d.png";